import { createRoot } from 'react-dom/client';
import ReduxIndex from './ReduxIndex';
import LoginGate from './stories/LoginGate';
import { consumeToken } from './auth/token';

/**
 * Dev harness. In production the portal hands the token over with
 * `?id_token=`; locally there is no portal handoff to localhost, so when no
 * token is present (URL, sessionStorage or VITE_APP_JWT) the dev build shows
 * the same Cognito username / password gate the storybook uses. The public
 * self-registration page never needs a token.
 */
const hasToken = !!(consumeToken() || import.meta.env.VITE_APP_JWT);
const isPublicPage = window.location.pathname.startsWith('/self-register');
// The Cognito gate shows in dev builds, and in production builds that opt in
// (VITE_APP_ENABLE_LOGIN_GATE=1: sites without a portal handoff such as rep.cloudeoc.com).
const gateEnabled = import.meta.env.DEV || import.meta.env.VITE_APP_ENABLE_LOGIN_GATE === '1';
const useGate = gateEnabled && !hasToken && !isPublicPage;

createRoot(document.getElementById('root')!).render(
  useGate ? <LoginGate>{(jwt) => <ReduxIndex initialToken={jwt} />}</LoginGate> : <ReduxIndex />,
);
